import {ChronologicalCommentsSort} from '@github-ui/commenting/useCommentsSortPreference'
import {SortAscIcon, SortDescIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

import {type TimelineSort, useSelectedTimelineSort, useSetTimelineSort} from '../../../contexts/TimelineSortContext'

const sortConfigs = {
  [ChronologicalCommentsSort.NewestFirst]: {shortLabel: 'Newest', label: 'Newest first', Icon: SortDescIcon},
  [ChronologicalCommentsSort.OldestFirst]: {shortLabel: 'Oldest', label: 'Oldest first', Icon: SortAscIcon},
} as const

const availableSorts: readonly TimelineSort[] = [
  ChronologicalCommentsSort.NewestFirst,
  ChronologicalCommentsSort.OldestFirst,
]

export function TimelineSortMenu() {
  const currentSort = useSelectedTimelineSort()
  const setSort = useSetTimelineSort()
  const {Icon: CurrentSortIcon, shortLabel: currentSortLabel} = sortConfigs[currentSort]

  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton icon={CurrentSortIcon} aria-label={`Sort activity: ${currentSortLabel}`} />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single">
          {availableSorts.map(sort => {
            const {label, Icon} = sortConfigs[sort]
            return (
              <ActionList.Item
                key={sort}
                selected={sort === currentSort}
                onSelect={() => {
                  if (sort !== currentSort) setSort(sort)
                }}
              >
                <ActionList.LeadingVisual>
                  <Icon />
                </ActionList.LeadingVisual>
                {label}
              </ActionList.Item>
            )
          })}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
